/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DevCodeIcon16Light = forwardRef('DevCodeIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M10.23 2.14a.5.5 0 0 0-.96-.28l-3.5 12a.5.5 0 1 0 .96.28l3.5-12Z" }),
        React.createElement("path", { d: "M11.896 3.896a.5.5 0 0 1 .708 0l2.901 2.902a1.7 1.7 0 0 1 0 2.404l-2.901 2.902a.5.5 0 0 1-.707-.707l2.9-2.902a.7.7 0 0 0 0-.99l-2.9-2.901a.5.5 0 0 1 0-.708Z" }),
        React.createElement("path", { d: "M4.104 3.896a.5.5 0 0 1 0 .708L1.202 7.505a.7.7 0 0 0 0 .99l2.902 2.902a.5.5 0 1 1-.708.707L.495 9.202a1.7 1.7 0 0 1 0-2.404l2.901-2.902a.5.5 0 0 1 .708 0Z" })));
});
